import type { Avaliacao, AvaliacaoStatus, UpsertAvaliacaoCommand } from '@/domain/model/Avaliacao';
import type { AvaliacaoQuestao, AddQuestaoToAvaliacaoCommand } from '@/domain/model/AvaliacaoQuestao';
import type { Page } from '@/domain/model/Page';
import type { AvaliacaoGateway } from '@/application/port/out/AvaliacaoGateway';
import type {
  ListAvaliacoesUseCase, GetAvaliacaoUseCase, CreateAvaliacaoUseCase,
  UpdateAvaliacaoUseCase, PublishAvaliacaoUseCase, ArchiveAvaliacaoUseCase,
  DeleteAvaliacaoUseCase,
  ListAvaliacaoQuestoesUseCase, AddQuestaoToAvaliacaoUseCase,
  RemoveQuestaoFromAvaliacaoUseCase,
} from '@/application/port/in/AvaliacaoUseCase';

export class ListAvaliacoes implements ListAvaliacoesUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(p: { disciplineId?: string; status?: AvaliacaoStatus; page?: number; size?: number }): Promise<Page<Avaliacao>> {
    return this.g.list(p);
  }
}
export class GetAvaliacao implements GetAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(id: string): Promise<Avaliacao> { return this.g.get(id); }
}
export class CreateAvaliacao implements CreateAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(c: UpsertAvaliacaoCommand): Promise<Avaliacao> { return this.g.create(c); }
}
export class UpdateAvaliacao implements UpdateAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(id: string, c: UpsertAvaliacaoCommand): Promise<Avaliacao> { return this.g.update(id, c); }
}
export class PublishAvaliacao implements PublishAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(id: string): Promise<Avaliacao> { return this.g.publish(id); }
}
export class ArchiveAvaliacao implements ArchiveAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(id: string): Promise<Avaliacao> { return this.g.archive(id); }
}
export class DeleteAvaliacao implements DeleteAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(id: string): Promise<void> { return this.g.delete(id); }
}

// F.2.2b sub-resource
export class ListAvaliacaoQuestoes implements ListAvaliacaoQuestoesUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(avaliacaoId: string): Promise<AvaliacaoQuestao[]> { return this.g.listQuestoes(avaliacaoId); }
}
export class AddQuestaoToAvaliacao implements AddQuestaoToAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(avaliacaoId: string, c: AddQuestaoToAvaliacaoCommand): Promise<AvaliacaoQuestao> {
    return this.g.addQuestao(avaliacaoId, c);
  }
}
export class RemoveQuestaoFromAvaliacao implements RemoveQuestaoFromAvaliacaoUseCase {
  constructor(private readonly g: AvaliacaoGateway) {}
  execute(avaliacaoId: string, questaoId: string): Promise<void> {
    return this.g.removeQuestao(avaliacaoId, questaoId);
  }
}
